<div class="offer">
    <div class="summary-container">
        <div class="summary-title">
            <ng-container *ngIf="!complaint?.id">
                {{ 'COMPLAINT|Zgłaszanie reklamacji' | translate }}
            </ng-container>
            <ng-container *ngIf="complaint?.id">
                {{ 'COMPLAINT|Obsługa zgłoszenia reklamacji' | translate }}
            </ng-container>
        </div>
        <div *ngIf="complaint?.id" class="document-title">
            <p>
                {{ 'COMPLAINT|Zgłoszenie {documentNumber} z dnia {requestDate}' | translate : {documentNumber: complaint.documentNumber?.join(''), requestDate: (complaint.created | date) } }}
            </p>
        </div>
        <div class="icc-card document-order-number">
            <span class="icc-card__label">
                {{ 'COMPLAINT|Numer zamówienia' | translate }}
            </span>
            <span class="icc-card__detail">
                {{ orderDocumentNumber?.join('') }}
            </span>
        </div>
        <div *ngIf="orderPositionTitle" class="icc-card document-order-position">
            <span class="icc-card__label">
                {{ !isComplaintForEntireOrder ? ('COMPLAINT|Pozycja zamówienia' | translate) : ('COMPLAINT|Pozycje na zamówieniu' | translate) }}
            </span>
            <span *ngIf="!isComplaintForEntireOrder" class="icc-card__detail">
                {{ orderPositionTitle?.join('') }}
            </span>
            <div *ngIf="isComplaintForEntireOrder" class="multiple-positions-container">
                <span class="icc-card__detail" *ngFor="let title of orderPositionTitle">
                    {{ title }}
                </span>
            </div>
        </div>
        <div class="icc-card document-status-card" *ngIf="complaint?.id">
            <span class="icc-card__label">
                {{ 'COMPLAINT|Status:' | translate }}
            </span>
            <span class="icc-card__detail">
                <icc-complaint-v1-status *ngIf="!hasAccessTo.manage" [status]="complaint.status"></icc-complaint-v1-status>
                <icc-form-field
                    size="small"
                    *ngIf="hasAccessTo.manage"
                >
                    <icc-icon name="state"  [ngStyle]="{'color': '#'+statusColorHex}" ></icc-icon>
                    <icc-select
                        size="small"
                        [value]="complaint.status"
                        (valueChange)="changeStatus($event)"
                        name="document-status"
                        >
                        <option *ngFor="let el of complaintStatuses" [value]="el.value" >
                            {{ el.label | translate}}
                        </option>
                    </icc-select>
                </icc-form-field>

            </span>
        </div>

        <div class="flex-horizontal wrap-conditional" *ngIf="complaint?.id">
            <div class="document-card_data">
                <span class="document-card_data__label">
                    {{ 'COMPLAINT|Zgłaszający:' | translate }}
                </span>
                <div class="document-card_data__content">
                    <div class="document-card_data__content-box">
                        <span class="document-card_data__content-box__wrapper">
                            <b class="document-card_data__content-box__company_name">{{ complaint?.contractorCompanyName }} <span *ngIf="complaint?.contractorExtId">({{ complaint?.contractorExtId }})</span><br></b>
                            <span>{{ complaint?.contractorName }}<br></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div id="document-actions" *ngIf="hasAccessTo.manage && complaint?.id">
            <div class="document-actions-row">
                <div class="document-actions-bar document-actions-bar__left">
                </div>

                <div class="document-actions-bar"></div>
                <div class="document-actions-bar document-actions-bar__right">
                    <button
                        iccButton
                        appearance="secondary"
                        data-test="send-history"
                        *ngIf="hasAccessTo.manage"
                        (click)="sendHistory()"
                    >
                        <icc-icon name="email"></icc-icon>
                        {{ 'COMPLAINT|Przekaż historię reklamacji na e-mail' | translate }}
                    </button>
                    <button
                        iccButton
                        appearance="secondary"
                        data-test="create-complaint-transport"
                        *ngIf="hasAccessTo.manage"
                        (click)="requestTransport()"
                    >
                        <icc-icon name="add_to_cart"></icc-icon>
                        {{ 'COMPLAINT|Zgłoś transport' | translate }}
                    </button>
                </div>
            </div>
        </div>

    </div>

    <div class="position-description">
        <span class="title">{{ 'INTERFACE|Opis' | translate }}</span>

        <div class="icc-card">
            <div class="icc-element" *ngIf="!complaint?.id">
                <textarea [ngModel]="complaint?.description" (ngModelChange)="changeDescription($event)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus [placeholder]="'INTERFACE|Kliknij, aby ustawić opis' | translate"></textarea>
            </div>

            <p  class="document-description" *ngIf="complaint?.id">
                {{complaint.description}}
            </p>
        </div>
    </div>

    <div class="complaint-attachments" *ngIf="!complaint?.id || attachments?.length">
        <span class="title">{{ 'INTERFACE|Załączniki' | translate }}</span>

        <div *ngIf="!complaint?.id" class="icc-card" >
            <span class="icc-card__label">{{ 'INTERFACE|Dodaj załącznik' | translate }}</span>

            <div class="file-picker">
                <input
                    type="file"
                    multiple
                    accept="application/pdf, image/jpeg, image/png, application/msword, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    value=""
                    (change)="addAttachment($event.target.files)"
                ><br>
                <small>{{ 'INTERFACE|Akceptowane pliki to pdf, doc, docx, jpg i png.' | translate }}</small>
            </div>
        </div>

        <div class="attachments-list">
            <div *ngFor="let attachment of attachments" class="attachment">
                <a class="attachment-label" [href]="'/complaints-v1-attachments/' + attachment.uuid" [download]="attachment.filename" >
                    {{attachment.filename}}
                </a>
                <button *ngIf="!complaint?.id" iccIconButton (click)="deleteAttachment(attachment)" [title]="'INTERFACE|Usuń' | translate" appearance="flat-base">
                    <icc-icon name="delete"></icc-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="complaint-actions" *ngIf="!complaint?.id">
        <button iccButton appearance="primary" (click)="sendComplaint()" id="new-complaint-button">{{ 'COMPLAINT|Zgłoś reklamację' | translate }}</button>
    </div>


    <div class="messages" *ngIf="complaint?.id">
        <span class="title">{{ 'COMPLAINT|Wiadomości' | translate }}</span>
        <div class="new-message">
            <textarea [ngModel]="newMessage" (ngModelChange)="newMessage = $event" name="new-message" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus [placeholder]="'COMPLAINT|Wpisz wiadomość' | translate"></textarea>
            <button iccButton appearance="primary" (click)="sendMessage()" id="new-message-button">{{ 'INTERFACE|Wyślij' | translate }}</button>
        </div>
        <div class="messages-list">
            <div *ngFor="let message of messages" class="message">
                <div class="message-header">
                    <b>{{ message.userName }}</b>
                    <span>{{ message.companyName }}</span>
                    <span>{{ message.created | date: 'short' }}</span>
                </div>
                <div class="message-content" >
                    {{ message.message }}
                </div>
            </div>
        </div>
    </div>

</div>